import React from 'react';
import { Button } from '@radix-ui/themes';
import { useDispatch, useSelector } from 'react-redux';
import useLanguage from '../../contexts/language/LanguageContext';
import { LoaderSvg } from '../../styles/icons/LoaderSvg';
import { removeSelectedPageFromHistory, setSelectedPage } from '../../store/slices/app/appSlice';
import { RootState } from '../../store/store';

type Props = {
  backText?: string,
  backUrl?: boolean | string,
  continueText?: string,
  showLoaderInContinueBtn?: boolean,
  onBack?: () => void,
  onContinue?: () => void
  disabledBackBtn?: boolean,
  disabledContinueBtn?: boolean,
}

export const Footer = (props: Props): React.ReactElement => {
  const appState = useSelector((state: RootState) => state.app)
  const language = useLanguage();
  const dispatch = useDispatch()

  const onClickBack = () => {
    if (props.onBack) {
      props.onBack()
      return
    }

    if (!props.backUrl) {
      return
    }

    dispatch(removeSelectedPageFromHistory())

    if(typeof props.backUrl === 'string') {
      dispatch(setSelectedPage({ url: props.backUrl, addToHistory: false }))
      return;
    }

    dispatch(setSelectedPage({ url: appState.selectedPageHistory[appState.selectedPageHistory.length - 1], addToHistory: false }))
  }

  return (
    <div className={`flex items-center w-full mt-10 ${!props.backUrl ? 'justify-end' : 'justify-between'}`}>
      {
        props.backUrl
          ? <Button variant="surface" size="4" onClick={onClickBack} disabled={props.disabledBackBtn}>
            { props.backText ? props.backText : language.translations.general.back }
          </Button>
          : <></>
      }

      {
        props.onContinue
          ? <Button variant="solid" size="4" onClick={props.onContinue} disabled={props.disabledContinueBtn}>
            {props.showLoaderInContinueBtn && (
              <LoaderSvg fill="white" />
            )}
            {props.continueText ? props.continueText : language.translations.general.continue }
          </Button>
          : <></>
      }
    </div>
  )
}
